import { MODULE_CONFIG } from "../../config/setup"

const states = {
  voice_agents_details: {
    records: [],
    vLoading: false,
    vLoadError: false,
    totalVoiceAgents: 0,
    searchKey: "",
    pageSize: MODULE_CONFIG.VOICE_AGENT.AGENTS_PER_PAGE_TABLE_DATA,
    currentPage: 1,
    selectedConfig: "default",
    selectedAgentDetails: {
      promptInfo: {},
      setting: {},
    },
    // prompt
    promptDetails: {},
    agentName: "",
    description: "",
    dynamicVariables: [],
    loading: false,
    settingData: {},
    sLoading: false,
    sLoadError: false,
  },
}

export default states
